/**
 * @param {Object} props
 * @param {string} props.message - Message to display when there are no relations.
 */
function EmptyState({ message }) {
  return (
    <div
      className="gx-d-flex gx-justify-content-center gx-align-items-center"
      style={{
        border: '1px dashed #e8e8e8',
        borderRadius: 4,
        padding: '24px 12px',
        color: '#bfbfbf',
      }}
    >
      {message}
    </div>
  );
}

export default EmptyState;
